module.exports = __webpack_public_path__ + "media/images/emoticons/eyeglass-ed740c3111c1cfc6c127f97dfc7ff732.gif";